var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileEditng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55981 9.87624H5.8014C5.5574 9.87624 5.35938 9.67821 5.35938 9.43421C5.35938 9.19022 5.5574 8.99219 5.8014 8.99219H9.55981C9.80381 8.99219 10.0018 9.19022 10.0018 9.43421C10.0018 9.67821 9.80381 9.87624 9.55981 9.87624Z",
    fill: "#F6821F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39123 4.53849L8.1145 3.57493C8.47284 3.09754 8.62372 2.50935 8.53944 1.91821C8.45516 1.32707 8.14633 0.804892 7.66894 0.446556C6.6841 -0.292513 5.28022 -0.093896 4.54056 0.892119L0.561137 6.1935C-0.624674 7.77478 0.430297 9.6584 0.475678 9.73797C0.536973 9.84465 0.640112 9.92067 0.760344 9.94837C0.794527 9.95662 1.12457 10.0297 1.58487 10.0297C2.32924 10.0297 3.41251 9.83934 4.13508 8.87631L7.29917 4.66114C7.31755 4.64381 7.33471 4.62472 7.35038 4.60385C7.36612 4.58293 7.37973 4.56107 7.39123 4.53849ZM1.15522 9.11795C1.61552 9.17394 2.77658 9.21343 3.42783 8.34529L6.37238 4.42256L4.21252 2.80093L1.26779 6.72393C0.603572 7.61035 0.96898 8.69537 1.15522 9.11795ZM4.74307 2.0942L6.90323 3.71535L7.40726 3.04391C7.85459 2.44865 7.73377 1.60054 7.1385 1.15321C6.54265 0.707057 5.69396 0.827883 5.24722 1.42255L4.74307 2.0942Z",
    fill: "#F6821F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditng);
export default __webpack_public_path__ + "static/media/profile_editng.69fd2994607bc77c0fafa8f532ce4f2a.svg";
export { ForwardRef as ReactComponent };